import '@fontsource-variable/dm-sans/wght.css';
import '@fontsource-variable/fraunces/full.css';
import '@fontsource-variable/caveat/wght.css';
import './styles/index.css';

import {ensureRandomUUID} from './core/dom.js';
import {initMotion} from './core/motion.js';
import {SoundManager} from './core/sound-manager.js';
import {initNavigation} from './core/navigation.js';
import {initHome} from './screens/home.js';
import {initToolkit} from './screens/toolkit.js';
import {initRoll} from './tools/roll.js';
import {initJar} from './tools/jar.js';
import {initMvd} from './tools/mvd.js';
import {initParkingLot} from './tools/parking-lot.js';
import {initGoalFilter} from './tools/goal-filter.js';
import {installCompletionUI} from './screens/completion-ui.js';
import {initCompletion} from './screens/completion.js';
import {inspectStoredData} from './core/data-transfer.js';
import {installRefinement} from './screens/refinement.js';
import {initNextStep} from './screens/next-step.js';

ensureRandomUUID();
const recovered=inspectStoredData();
installCompletionUI();
installRefinement();
let navigation;
const motion=initMotion({say:message=>navigation?.say(message)});
SoundManager.init();
navigation=initNavigation({motion});
const jar=initJar({motion,navigation,sound:SoundManager});
const parkingLot=initParkingLot({motion,navigation,sound:SoundManager});
const roll=initRoll({motion,navigation,sound:SoundManager,parkingLot});
initMvd({motion,navigation,sound:SoundManager});
initGoalFilter({motion,navigation,sound:SoundManager});
initHome({motion,navigation,sound:SoundManager});
initToolkit({navigation});
initCompletion({navigation,motion,sound:SoundManager,roll,jar,recovered});
initNextStep({roll,navigation});
const initial=location.hash.slice(1);if(initial)navigation.showScreen(initial);
